import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  perform() {
    window.scroll({ top: 0, behavior: 'smooth' })
  }
}
